import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { CheckCircle } from 'lucide-react';
import { changePassword } from './../../api/BackendApi';

const ChangePasswordPage = () => {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({ 
    currentPassword: '', 
    newPassword: '', 
    confirmPassword: '' 
  });
  const [error, setError] = useState('');
  const [isSaving, setIsSaving] = useState(false);
  const [isSuccess, setIsSuccess] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    
    // TVRDÝ BLOK pro maximální délku 50 znaků u hesla
    if (value.length > 50) return;
    
    setFormData(prev => ({ ...prev, [name]: value }));
    if (error) setError('');
  };

  const handleSubmit = async (e) => {
    e.preventDefault(); // Klíčové: zabrání odeslání a obnovení stránky
    
    // 1. RUČNÍ VALIDACE (ČESKY)
    if (!formData.currentPassword || !formData.newPassword || !formData.confirmPassword) {
      return setError('Prosím, vyplňte všechna pole.');
    }

    if (formData.newPassword !== formData.confirmPassword) {
      return setError('Nová hesla se neshodují.');
    }

    if (formData.newPassword.length < 8) {
      return setError('Nové heslo musí mít alespoň 8 znaků.');
    }

    // 2. ODESLÁNÍ
    setIsSaving(true);
    setError('');
    
    try {
      await changePassword({
        currentPassword: formData.currentPassword,
        newPassword: formData.newPassword
      });
      // ÚSPĚCH
      setIsSuccess(true);
    } catch (err) {
      setError(err.message || err.error || 'Změna hesla selhala. Zkontrolujte stávající heslo.');
    } finally {
      setIsSaving(false);
    }
  };

  if (isSuccess) {
    return (
      <div className="container mx-auto px-4 py-16 max-w-md text-center">
        <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-8">
          <CheckCircle className="text-green-500 w-16 h-16 mx-auto mb-4" />
          <h2 className="text-2xl font-bold text-gray-900 mb-2">Heslo bylo změněno</h2>
          <p className="text-gray-600 mb-8">
            Vaše heslo bylo úspěšně aktualizováno. Nyní můžete pokračovat.
          </p>
          <button 
            type="button"
            onClick={() => navigate('/account')}
            className="w-full px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 font-medium transition-colors"
          >
            Zpět na účet
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="container mx-auto px-4 py-8 max-w-md">
      <h1 className="text-2xl font-bold text-gray-900 mb-6">Změna hesla</h1>
      
      <div className="bg-white rounded-xl shadow-sm border border-gray-200 overflow-hidden">
        {/* Atribut noValidate opět zabrání výchozím anglickým hláškám */}
        <form onSubmit={handleSubmit} noValidate className="p-6">
          
          {error && (
            <div className="mb-6 p-4 bg-red-50 text-red-700 text-sm font-medium rounded-lg border border-red-200">
              {error}
            </div>
          )}

          <div className="space-y-4 mb-6">
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">
                Aktuální heslo <span className="text-red-500">*</span>
              </label>
              <input 
                type="password" 
                name="currentPassword" 
                value={formData.currentPassword} 
                onChange={handleChange} 
                className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500" 
              />
            </div>
            
            <div className="pt-4 border-t border-gray-100">
              <label className="block text-sm font-medium text-gray-700 mb-1">
                Nové heslo <span className="text-red-500">*</span>
              </label>
              <input 
                type="password" 
                name="newPassword" 
                value={formData.newPassword} 
                onChange={handleChange} 
                className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500" 
              />
            </div>

            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">
                Potvrzení nového hesla <span className="text-red-500">*</span>
              </label>
              <input 
                type="password" 
                name="confirmPassword" 
                value={formData.confirmPassword} 
                onChange={handleChange} 
                className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500" 
              />
            </div>
          </div>

          <div className="flex items-center justify-end gap-4 mt-8">
            <button 
              type="button" 
              disabled={isSaving}
              onClick={() => navigate('/account')}
              className="px-4 py-2 text-gray-700 bg-white border border-gray-300 rounded-lg hover:bg-gray-50 font-medium text-sm transition-colors disabled:opacity-50"
            >
              Zrušit
            </button>
            <button 
              type="submit" 
              disabled={isSaving}
              className="px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 font-medium text-sm transition-colors disabled:opacity-50"
            >
              {isSaving ? 'Ukládám...' : 'Změnit heslo'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default ChangePasswordPage;